import React from 'react';

const WithCount = ({count, children}) => <>{children}{count && <span className='ml-1 muted'>({count})</span>}</>

export default function AutoGroupValueRenderer(params) {
  const {value, valueFormatted, data} = params;
  const childCount = data?.childCount;

  // Must match DatagridQueryService::UNDEFINED_VALUE
  if (value === '#UNDEF_VALUE') return <WithCount count={childCount}><span className='muted'>{I18n.t('undefined')}</span></WithCount>;

  if (valueFormatted) return <WithCount count={childCount}>{valueFormatted}</WithCount>;
  if (value != null) return <WithCount count={childCount}>{value}</WithCount>;
  return <WithCount>{value}</WithCount>;
}